import React from "react"
import { Col, Container, Row, Visible } from "react-grid-system"
import { Fade } from "react-reveal"
import styled from "styled-components"
import { breakpoint } from "../../utils/breakpoint"
import ClickHereToDownloadMobileLeft from "../ClickHereToDownload/MobileLeft"
import ClickHereToDownloadDesktop from "../ClickHereToDownload/Desktop"

const StyledFooter = styled.footer`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 30px;
  width: 100%;
  align-items: center;
  background: linear-gradient(180deg, white 25.37%, #0f6497 102.25%);
  overflow-x: hidden;
`

const StyledFooterTextWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 70%;
  background-color: #0f6495;
  padding-top: 1.1em;
  padding-bottom: 1.1em;
  padding-right: 1.1em;
  padding-left: 30px;
  margin-bottom: 30px;

  background: #0f6495;

  ${breakpoint.sm} {
    width: 47%;
  }

  ${breakpoint.md} {
    width: 45%;
  }
  ${breakpoint.lg} {
    width: 40%;
  }

  ${breakpoint.xl} {
    width: 50%;
  }
`
const StyledFooterTextLargeScreenWrapper = styled.div`
  width: 100%;
  background-color: #0f6495;
  padding-top: 1.1em;
  padding-bottom: 1.1em;
  padding-right: 1.1em;
  padding-left: 30px;
  margin-bottom: 30px;

  background: #0f6495;

  ${breakpoint.md} {
    width: 50%;
  }

  ${breakpoint.lg} {
    width: 50%;
  }

  ${breakpoint.xl} {
    width: 45%;
  }
`

export const StyledDisclaimerText = styled.div`
  font-family: "Lato", georgia, serif;
  font-style: normal;
  font-weight: 500;
  font-size: 0.8em;
  line-height: 1.2;
  /* or 117% */

  color: #ffffff;

  ${breakpoint.md} {
    font-size: 0.85em;
  }

  ${breakpoint.lg} {
    font-size: 0.95em;
  }
`

const StyledClickHereToDownloadWrapper = styled.div`
  width: 100%;
  margin-top: 163px;
  margin-bottom: 120px;

  ${breakpoint.lg} {
    margin-bottom: 350px;
  }
`

const FooterSection = () => {
  return (
    <StyledFooter>
      <Visible xs sm md>
        <StyledClickHereToDownloadWrapper>
          <Fade ssrReveal left>
            <ClickHereToDownloadMobileLeft />
          </Fade>
        </StyledClickHereToDownloadWrapper>
      </Visible>
      <Visible lg xl xxl>
        <Container fluid xs sm md style={{ width: "100%" }}>
          <Row>
            <Col lg={6} xl={5}>
              <StyledClickHereToDownloadWrapper>
                <Fade ssrReveal left>
                  <ClickHereToDownloadDesktop />
                </Fade>
              </StyledClickHereToDownloadWrapper>
            </Col>
          </Row>
        </Container>
      </Visible>
      <Container fluid xs sm md>
        <StyledDisclaimerText>
          The information contained in this report is provided by ABC World Asia
          for information purposes only. ABC World Asia makes no representation
          as to the completeness and accuracy of the information in this report,
          and assumes no responsibility for updating such information. ABC World
          Asia accepts no liability for any losses arising from any action taken
          or refrained from as a result of information in this report or any
          sources of information referred to in this report. The information in
          this report may not be reproduced either in part or in full without
          the written permission of ABC World Asia.
        </StyledDisclaimerText>
      </Container>
    </StyledFooter>
  )
}

export default FooterSection
